<template>
  <SanFieldInput
    v-model="keyword"
    class="san-field-searchbox"
    name="search-input"
    :placeholder="placeholder"
    :loading="isLoading"
    :autofocus="autofocus"
    :disable="isLoading"
    :debounce="debounce"
    hide-bottom-space
    dense
    @focus="emit('focus', $event)"
    @blur="emit('blur', $event)"
    @clear="emit('clear')"
    @update:model-value="onUpdateQueryParams"
  >
    <template #prepend>
      <q-icon name="mono-search" />
    </template>

    <template #append>
      <q-icon
        v-if="keyword !== ''"
        name="mono-cross"
        class="cursor-pointer"
        @click="keyword = ''"
      />
      <q-icon name="mono-search" />
    </template>

    <template #loading>
      <slot name="loading-indicator" />
    </template>
  </SanFieldInput>
</template>

<script setup>
import { watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

defineOptions({ name: 'SanFieldSearch' })
const keyword = defineModel({ type: String, default: undefined })
const emit = defineEmits(['update:modelValue', 'focus', 'blur', 'clear'])
const props = defineProps({
  placeholder: { type: String, default: '' },
  autofocus: { type: Boolean, default: true },
  isLoading: { type: Boolean, default: false },
  debounce: { type: Number, default: 300 }
})

const $router = useRouter()
const $route = useRoute()

keyword.value = $route.query?.q

const onUpdateQueryParams = () => {
  $router.replace({
    query: {
      ...$route.query,
      q: keyword.value || undefined
    }
  })
}

watch(() => keyword.value, val => {
  emit('update:modelValue', val)
})

</script>

<style lang="scss">
.san-searchbox {
  display: flex;
  align-items: center;

  .san-field-searchbox {
    padding: 0;
    width: 250px;

    .q-field__control {
      &::before {
        background: var(--q-background-mid);
      }
    }
  }
}
</style>
